import * as THREE from 'three'
import { StyleSheet } from 'react-native'
import { Scene } from '../../b.providers/ScenesProvider/Scenes'
import { OrbitControls, OrthographicCamera, PerspectiveCamera, Stats } from '@react-three/drei'
import GameSceneElements from './GameSceneElements'
import { Vector3 } from 'three'

const GameScene = () => {
  return (
    <Scene // alias for r3f Canvas
      // we need to flatten styles or Canvas will not taking it
      style={StyleSheet.flatten(styles.canvas)}
      shadows
      camera={{ position: [-44.94595276688382, 61.092773125484136, -0.635300152496112], fov: 60, near: 2, zoom: 4.5 }}
      // camera={{ position: [0, 8, 15], fov: 60, near: 2 }}
      gl={{ antialias: true }}
      onCreated={({ gl: renderer, scene, camera }) => {
        // renderer.physicallyCorrectLights = true
        // renderer.outputEncoding = THREE.sRGBEncoding
        // renderer.setClearColor('#24223b', 1)
        // renderer.shadowMap.enabled = true
        // renderer.shadowMap.type = THREE.PCFSoftShadowMap

        // window._cam = camera
      }}
    >
      <GameSceneElements />

      {/* <OrbitControls /> */}
      {/* <Stats /> */}
    </Scene>
  )
}

const styles = StyleSheet.create({
  canvas: { backgroundColor: 'black', flex: 1, flexBasis: '100%', position: 'absolute' },
})

export default GameScene
